import type Translations from '@lved/ui/components/shared/ui/Tabs/Translations';
import { ReactWidget } from '@theia/core/lib/browser';
import { injectable, postConstruct } from '@theia/core/shared/inversify';

type TranslationsModule = { Translations: typeof Translations };

@injectable()
export class TranslationsPanel extends ReactWidget {
    static readonly ID: string = 'widget:lvgl-translations';
    static readonly LABEL: string = 'Translations';

    protected module: TranslationsModule | undefined;
    protected loadError: string | undefined;

    @postConstruct()
    protected init(): void {
        this.doInit();
    }

    protected async doInit(): Promise<void> {
        this.id = TranslationsPanel.ID;
        this.title.label = TranslationsPanel.LABEL;
        this.title.caption = TranslationsPanel.LABEL;
        this.title.closable = true;
        await this.loadModule();
        this.update();
    }

    protected async loadModule(): Promise<void> {
        try {
            this.module = (await import('@lved/ui')) as unknown as TranslationsModule;
        } catch (error: unknown) {
            this.loadError = error instanceof Error ? error.message : 'Failed to load Translations panel.';
        }
    }

    protected render(): JSX.Element {
        if (this.loadError) return <p>{this.loadError}</p>;
        if (!this.module) return <p>Loading Translations...</p>;
        const { Translations } = this.module;
        return <Translations />;
    }
}
